import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteImplantacaoEstoqueProducao } from '../service';
import {
  DELETE_IMPLANTACAO_ESTOQUE_PRODUCAO,
  DELETE_IMPLANTACAO_ESTOQUE_PRODUCAO_PENDING,
  DELETE_IMPLANTACAO_ESTOQUE_PRODUCAO_SUCCESS,
  DELETE_IMPLANTACAO_ESTOQUE_PRODUCAO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteImplantacaoEstoqueProducao(action) {
  yield put({ type: DELETE_IMPLANTACAO_ESTOQUE_PRODUCAO_PENDING, id: action.id })

  try {
    const a = yield call(deleteImplantacaoEstoqueProducao, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_IMPLANTACAO_ESTOQUE_PRODUCAO_SUCCESS, id: action.id });

    trackingEventCX('action', MODULE_ACTIONS_ENUM.IMPLANTACAO_ESTOQUE_AGRICOLA_EXCLUIR);

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_IMPLANTACAO_ESTOQUE_PRODUCAO_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeleteImplantacaoEstoqueProducao() {
  yield takeLatest(DELETE_IMPLANTACAO_ESTOQUE_PRODUCAO, sagaDeleteImplantacaoEstoqueProducao)
}
